import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Field,
  Label,
} from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/16/solid";
import React from "react";

export interface SelectOption<T = string> {
  value: T;
  label: string;
}

// type SelectOption = {
//   value: ModuleStatus;
//   label: string;
// };

interface SelectProps {
  label?: string;
  className?: string;
  value: SelectOption;
  options: SelectOption[];
  onChange: (val: SelectOption) => void;
  isDisabled?: boolean;
}

export default function Select({
  value,
  label,
  className,
  options,
  onChange,
  isDisabled = false,
}: SelectProps) {
  return (
    <div className={`relative ${className} w-full h-[48px]`}>
      <Field>
        {label && <Label>{label}</Label>}
        <Listbox value={value} onChange={onChange} disabled={isDisabled}>
          {({ open }) => (
            <>
              <ListboxButton
                className={`relative block w-full py-2 pr-8 pl-4 font-semibold text-left text-gray-700 border round-border-gray-300 rounded-md${
                  open ? "rounded-t-md" : "rounded-md"
                } ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={isDisabled}
              >
                {value.label}
                {open ? (
                  <ChevronUpIcon
                    className="group pointer-events-none absolute top-2.5 right-2.5 w-5 h-5 fill"
                    aria-hidden="true"
                  />
                ) : (
                  <ChevronDownIcon
                    className="group pointer-events-none absolute top-2.5 right-2.5 w-5 h-5 fill"
                    aria-hidden="true"
                  />
                )}
              </ListboxButton>
              {!isDisabled && open && (
                <ListboxOptions className="absolute z-10 w-full bg-electrum-100 font-semibold text-left text-electrum-800 py-1 border-t border-electrum-500 rounded-md shadow-lg">
                  {options.map((option) => (
                    <ListboxOption key={option.value} value={option}>
                      {({ active }) => (
                        <div
                          className={`cursor-pointer select-none relative py-2 pl-6 pr-4 ${
                            active ? "bg-electrum-300 text-electrum-900" : ""
                          } hover:bg-electrum-300`}
                        >
                          {option.label}
                        </div>
                      )}
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              )}
            </>
          )}
        </Listbox>
      </Field>
    </div>
  );
}
